import { useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { useOtherSettings } from '@namespace/cms';
import { LOBBY_LIVE_RTP_GAMES_AMOUNT, SECTION_TYPES } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useCategory } from '../useCategory';
import { useGamesData } from '../useGamesData';
import { useGetIsEmptyLiveRtpCategory } from '../useGetIsEmptyLiveRtpCategory';
import { useGetIsLiveRtpGamesLoaded } from '../useGetIsLiveRtpGamesLoaded';
import { useGetLiveRtpMixedGamesIds } from '../useGetLiveRtpMixedGamesIds';

export const useLiveRtpGamesCategory = (
  feedName: string,
  casinoType: CasinoTypeUnion
) => {
  const gamesData = useGamesData();
  const { casinoDynamicCategoriesIds = {} } = useOtherSettings();
  const isLiveRtpGamesLoaded = useGetIsLiveRtpGamesLoaded();
  const feedLiveRtpCategory = useCategory(
    casinoDynamicCategoriesIds.liveRtp,
    feedName,
    casinoType
  );
  const isEmptyLiveRtpCategory = useGetIsEmptyLiveRtpCategory(feedName);

  const lobbyLiveRtpGamesIds = useGetLiveRtpMixedGamesIds({
    feedName
  });

  const lobbyLiveRtpGames = useMemo(
    () => lobbyLiveRtpGamesIds.map((gameId) => gamesData[gameId]),
    [gamesData, lobbyLiveRtpGamesIds]
  );

  const preparedLiveRtpCategory = useMemo(
    () => ({
      ...(feedLiveRtpCategory ?? {}),
      type: SECTION_TYPES.CATEGORY_LIVE_RTP,
      isViewAllEnabled: true,
      categoryGames: lobbyLiveRtpGames,
      games: lobbyLiveRtpGamesIds,
      maxGamesAmount: LOBBY_LIVE_RTP_GAMES_AMOUNT,
      isCategoryLoading: !isLiveRtpGamesLoaded,
      isWithLiveRtpInfo: true
    }),
    [
      feedLiveRtpCategory,
      lobbyLiveRtpGames,
      lobbyLiveRtpGamesIds,
      isLiveRtpGamesLoaded
    ]
  );

  if (
    !casinoDynamicCategoriesIds?.liveRtp ||
    isEmptyLiveRtpCategory ||
    isEmpty(feedLiveRtpCategory)
  ) {
    return null;
  }

  return preparedLiveRtpCategory;
};
